module.exports = __webpack_public_path__ + "static/hero-illustration-a30929564f60319651eef554955ad631.png";